export const ImageHeightToScreenHeightRatio = 0.7;
